import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Rating } from 'src/app/models/rating';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ReviewandratingService {


	constructor(private http: HttpClient) { }


	url = environment.serverAPI1 + "/api/rating";
	url1 = environment.serverAPI1 + "/api/review";
	url2 = environment.serverAPI1 + "/api/reviews";


	searchRating(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}

	searchReview(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url2}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}

	getRating(Page: number, size: number, sort: number): Observable<Object> {
		return this.http.get(`${this.url}/?page=${Page}&size=${size}&sort=${sort}`);

	}

	createRating(rating: Rating): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}`, rating);
	}

	getRatingById(ratingId: number): Observable<Object> {
		return this.http.get(`${this.url}/${ratingId}`);
	}

	getPendingReview(Page: number, size: number, sort: number): Observable<Object> {
		return this.http.get(`${this.url1}?page=${Page}&size=${size}&sort=${sort}`);
	}

	getPendingReviewById(reviewId: number): Observable<Object> {
		return this.http.get(`${this.url1}/${reviewId}`);
	}

	createReview(review): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url1}`, review);
	}
	getAllCustomerReviewDropDown(): Observable<Object> {
		return this.http.get(`${this.url1}/dropdown`);
	}

}
